import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import * as powerPositionAPI from '../../services/PowerPositionAPI';
import { CLEAR_API_CALL_MESSAGE, GET_AI_SUGGESTION_DATA_POWER_POSITION, GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE, GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS, GET_POWER_POSITION_FAILURE, GET_POWER_POSITION_LIST, GET_POWER_POSITION_LIST_FAILURE, GET_POWER_POSITION_LIST_SUCCESS, UPDATE_DETAILED_NEGOTIATION_OVERVIEW } from "../../redux/Action/actionTypes";
import { apiCallFailure, apiCallRequest, getNegotiationTileDataAction } from "../Action/Action";

function* getAISuggestionPowerPositionData(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const payload = action.payload;
        const response: any = yield call(powerPositionAPI.getAISuggestionPowerPositionAPI, payload)
        if (response.status === 200) {
            yield put({ type: GET_AI_SUGGESTION_DATA_POWER_POSITION_SUCCESS, payload: response.data.result })
            yield put({ type: CLEAR_API_CALL_MESSAGE })
        } else {
            yield put({ type: GET_AI_SUGGESTION_DATA_POWER_POSITION_FAILURE, payload: "" })
            yield put(apiCallFailure("Failed to fetch AI recommendations.Please try again."))
        }

    } catch (e) {
        yield put({ type: GET_POWER_POSITION_FAILURE, payload: e })
        yield put(apiCallFailure("An error occurred while fetching AI recommendations. Please try again."))
    }
}

function* getPowerPositionListData(action: any): Generator {
    try {
        const response: any = yield call(powerPositionAPI.getPowerPositionListAPI);
        if (response.status === 200) {
            yield put({ type: GET_POWER_POSITION_LIST_SUCCESS, payload: response.data.result })
        } else {
            yield put({ type: GET_POWER_POSITION_LIST_FAILURE })
        }
    } catch (error) {
        yield put({ type: GET_POWER_POSITION_LIST_FAILURE })
    }
}

function* saveNegotiationFormsDataOnDetailedOverview(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const data = action.payload;
        const response: any = yield call(powerPositionAPI.saveNegotiationFormsDataOnDetailedOverviewAPI, data);
        if (response.status === 200) {
            yield put (getNegotiationTileDataAction(data.negotiationIdAndStatusData))
        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while saving your changes. Please try again."
                )
            );
            if(action.meta?.onFailure){
                action.meta.onFailure()
            }
        }
    } catch (e) {
        console.log(e)
        yield put(
            apiCallFailure(
                "An error occurred while saving your changes. Please try again."
            )
        );
        
        console.log(e);
         if(action.meta?.onFailure){
                action.meta.onFailure()
            }
    }
}



function* watchGetAISuggestionPowerPositionData(): Generator {
    yield takeLatest(GET_AI_SUGGESTION_DATA_POWER_POSITION, getAISuggestionPowerPositionData)
}

function* watchGetPowerPositionListData(): Generator {
    yield takeLatest(GET_POWER_POSITION_LIST, getPowerPositionListData);
}
function* watchSaveNegotiationFormsDataOnDetailedOverview(): Generator {
    yield takeLatest(UPDATE_DETAILED_NEGOTIATION_OVERVIEW, saveNegotiationFormsDataOnDetailedOverview);
}
export default function* PowerPositionSaga(): Generator {
    yield all([
        fork(watchGetAISuggestionPowerPositionData),
        fork(watchGetPowerPositionListData),
        fork(watchSaveNegotiationFormsDataOnDetailedOverview)
    ])
}